import React from 'react';

import analyticsBlack from '../assets/analytics-black.svg';
import analyticsGrey from '../assets/analytics-grey.svg';
import gridBlack from '../assets/grid-black.svg';
import gridGrey from '../assets/grid-grey.svg';
import settingsBlack from '../assets/settings-black.svg';
import settingsGrey from '../assets/settings-grey.svg';
import uploadBlack from '../assets/upload-black.svg';
import uploadGrey from '../assets/upload-grey.svg';
import usersBlack from '../assets/users-black.svg';
import usersGrey from '../assets/users-grey.svg';

const ICONS = {
    upload: { active: uploadBlack, inactive: uploadGrey },
    grid: { active: gridBlack, inactive: gridGrey },
    feeds: { active: analyticsBlack, inactive: analyticsGrey },
    users: { active: usersBlack, inactive: usersGrey },
    settings: { active: settingsBlack, inactive: settingsGrey }
};

/** Sidebar module icon from design assets: black when selected, grey otherwise. */
const NavIcon = ({ name, active, className = '' }) => {
    const icon = ICONS[name];
    if (!icon) return null;
    const width = name === 'settings' ? 20 : name === 'feeds' ? 15 : 16;
    const height = name === 'settings' ? 20 : name === 'feeds' ? 13 : 16;
    return (
        <img
            src={active ? icon.active : icon.inactive}
            alt=""
            width={width}
            height={height}
            className={`console-nav-icon ${className}`.trim()}
        />
    );
};

export default NavIcon;
